import { Icon } from "antd";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "use-lodash-debounce";
import DataTable from "../../../../common/components/DataTable/DataTable";
import { getPatientsByQuery, getPCMDetail, getPCMOverview, getPCMProvider, setGlobalLoading } from "../../../../store/actions";
import { StaticResource } from "../../constant";
import OverviewFilter from "./OverviewFilter";
import OverviewSidebar from "./OverviewSidebar";
let timer;

const Overview = ({ data, title, onFilterChange }) => {
  const [isSidebar, setIsSidebar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tableLoad, setTableLoads] = useState([]);
  const [offLoad, setOffLoad] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [userProvider, setUserProvider] = useState(null);
  const [customReport, setCustomReport] = useState(null);
  const [forFilter, setForFilter] = useState(false);
  const [activeIndex, setRow] = useState(-1);
  const [assignment, setAssignment] = useState(null);
  const [iconOverviewStatus, setIconOverviewStatus] = useState(null);
  const [lastScrollTop, setLastScrollTop] = useState(0); // Track last scroll position
  const [positiveIb, setPositiveIb] = useState(false); //track exclude 0 insurance balance

  const dispatch = useDispatch();
  const patients = useSelector((state) => state.dashboard.patients);
  const pcm = useSelector((state) => state.common.pcm_overview);
  const pcmDetail = useSelector((state) => state.common.pcmDetail);
  const ScheduleRow = useSelector((state) => state.common.pcmProvider);

  const [sortOption, setSortOption] = useState({});

  const sortList = async () => {
    const sortColumn = [];
    for (const sortOpt of Object.keys(sortOption)) {
      if (!!sortOption[sortOpt]) {
        sortColumn.push({ name: sortOpt, direction: sortOption[sortOpt] });
      }
    }

    setTableLoads([]);
    setLoading(true);
    setPage(1);
    if (!forFilter) {
      await dispatch(
        getPCMOverview(1, {
          startDate,
          search: search,
          column: sortColumn,
          overviewStatus: iconOverviewStatus,
          assignment: assignment,
          customReport: customReport,
          positiveIb: positiveIb,
        })
      );
      setLoading(false);
    } else {
      await dispatch(
        getPCMOverview(1, {
          startDate,
          search: search,
          column: sortColumn,
          overviewStatus: iconOverviewStatus,
          assignment: assignment,
          customReport: customReport,
          positiveIb: positiveIb,
        })
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    sortList();
  }, [sortOption, customReport]);

  const handleSortOption = (name, direction) => {
    const sortValue = { ...sortOption, [name]: direction };
    setSortOption(sortValue);
  };

  const handleSidebar = () => {
    setIsSidebar(true);
  };

  const valueSearch = async (value) => {
    clearTimeout(timer);
    setSearch(value);
    setLoading(true);
    timer = setTimeout(async () => {
      setTableLoads([]);
      setForFilter(true);
      setPage(1);
      await dispatch(
        getPCMOverview(1, {
          startDate,
          search: value,
          customReport: customReport,
        })
      );
      setLoading(false);
    }, 1000);
  };

  const handleCloseSidebar = () => {
    setIsSidebar(false);
  };

  const handleRow = async (row, index) => {
    if (activeIndex !== index) {
      setRow(index);
      setLoading(true);
      const detailSuccess = await dispatch(getPCMDetail(row?.id));
      if (detailSuccess) {
        setLoading(false);
      }
      handleSidebar();
    }
  };

  const fetchList = async () => {
    setLoading(true);
    const listProvider = await dispatch(getPCMProvider());
    if (listProvider) {
      setLoading(false);
    }
  };

  const debouncedValue = useDebounce(search, 400);

  const handleSearch = async () => {
    setLoading(true);
    await dispatch(getPatientsByQuery(search));
    setLoading(false);
  };

  useEffect(() => {
    if (debouncedValue) {
      handleSearch();
    }
  }, [debouncedValue]);

  const loadMore = async (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 30; // px of the bottom
    const t = (scrollTop + pad) / (scrollHeight - clientHeight);
    const isScrollingDown = scrollTop > lastScrollTop; // Check scroll direction

    setLastScrollTop(scrollTop); // Update last scroll position

    const sortColumn = [];
    for (const sortOpt of Object.keys(sortOption)) {
      if (!!sortOption[sortOpt]) {
        sortColumn.push({ name: sortOpt, direction: sortOption[sortOpt] });
      }
    }
    if (t >= 1 && Number.isFinite(t) && !loading && isScrollingDown) {
      setLoading(true);
      if (offLoad && !forFilter) {
        const listPCM = await dispatch(
          getPCMOverview(page + 1, {
            column: sortColumn,
            overviewStatus: iconOverviewStatus,
            assignment: assignment,
            customReport: customReport,
            positiveIb: positiveIb,
          })
        );
        if (listPCM) {
          if (pcm && pcm.list && pcm.list.length > 0) {
            setPage(page + 1);
            setLoading(false);
          } else {
            setLoading(false);
            setOffLoad(false);
          }
        }
      } else if (offLoad && forFilter) {
        const listPCMFilter = await dispatch(
          getPCMOverview(page + 1, {
            startDate,
            search: search,
            column: sortColumn,
            overviewStatus: iconOverviewStatus,
            assignment: assignment,
            customReport: customReport,
            positiveIb: positiveIb,
          })
        );
        if (listPCMFilter) {
          if (pcm && pcm.list && pcm.list.length > 0) {
            setPage(page + 1);
            setLoading(false);
          } else {
            setLoading(false);
            setOffLoad(false);
          }
        }
      }
    }
  };

  const onChangeDate = (value) => {
    const date = moment(value).format("MM/DD/YYYY");
    setStartDate(date);
  };

  const onChangeAssignment = (value) => {
    if (value === "insurance_aging") {
      onSelectCustomReport(value);
      setAssignment(null);
      setIconOverviewStatus(null);
      onFilterChange({
        assignment: null,
        icon_overview_status: null,
        custom_report: value,
        positive_ib: positiveIb,
      });
    } else if (value === "ok_waiting_payment" || value === "needs_review" || value === "attention_required") {
      setAssignment(value);
      setIconOverviewStatus(null);
      setCustomReport(null);
      onFilterChange({
        assignment: value,
        icon_overview_status: null,
        custom_report: null,
        positive_ib: positiveIb,
      });
    } else {
      setIconOverviewStatus(value);
      setAssignment(null);
      setCustomReport(null);
      onFilterChange({
        assignment: null,
        icon_overview_status: value,
        custom_report: null,
        positive_ib: positiveIb,
      });
    }
  };

  const onChangeSlary = async (value) => {
    setLoading(true);
    setTableLoads([]);
    const filterSuccess = await dispatch(
      getPCMOverview(1, {
        assignment: assignment,
        overviewStatus: iconOverviewStatus,
        startDate: startDate,
        search: search,
        customReport: customReport,
        netMin: value[0],
        netMax: value[1],
        positiveIb: positiveIb,
      })
    );
    if (filterSuccess) {
      setLoading(false);
    }
  };

  const onSelectCustomReport = (value) => {
    switch (value) {
      case "insurance_aging":
        setCustomReport(value);
        setSortOption({
          ...sortOption,
          aging: "asc",
        });
        break;

      default:
        setSortOption({});
        setCustomReport(null);
        break;
    }
  };

  const callApiFilter = async (type) => {
    setLoading(true);
    setTableLoads([]);
    const filterSuccess = await dispatch(
      getPCMOverview(1, {
        assignment: assignment,
        overviewStatus: iconOverviewStatus,
        startDate: startDate,
        search: search,
        customReport: customReport,
        positiveIb: positiveIb,
      })
    );
    if (filterSuccess) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (startDate && !userProvider) {
      setPage(1);
      setTableLoads([]);
      callApiFilter("full");
      setForFilter(true);
    } else if (userProvider && startDate) {
      setPage(1);
      setTableLoads([]);
      callApiFilter("full");
      setForFilter(true);
    } else if (userProvider && !startDate) {
      setPage(1);
      setTableLoads([]);
      callApiFilter("user");
      setForFilter(true);
    } else {
      setPage(1);
      setTableLoads([]);
      callApiFilter("full");
      setForFilter(true);
    }
  }, [userProvider, startDate, assignment, iconOverviewStatus, positiveIb]);

  const updateState = (value, data) => {
    const tasks = tableLoad;
    setTableLoads(
      tasks.map((r) => {
        if (r?.id === value?.id) {
          return { ...r, direct_cost: data?.direct };
        } else {
          return r;
        }
      })
    );
  };

  const updateLocal = (value) => {
    const index = tableLoad.findIndex((r) => r?.id == value?.id);
    if (index != -1) {
      const arr = [...tableLoad];
      arr[index]["assignment"] = value.status;
      setTableLoads([...arr]);
    }
  };

  const moveState = (id, data) => {
    const tasks = tableLoad;
    setTableLoads(
      tasks.filter((r) => {
        if (r?.id !== id) {
          return r;
        }
      })
    );
    setRow(-1);
  };

  useEffect(() => {
    if (pcm && pcm.list && pcm.list.length > 0) {
      setTableLoads((prevTableLoad) => [...prevTableLoad, ...pcm.list]); // Append new data
    }
  }, [pcm]);

  useEffect(() => {
    dispatch(setGlobalLoading(loading));
  }, [loading]);

  const onSelectFilter0IB = (e) => {
    setPositiveIb(e.target.checked);
    onFilterChange({
      positive_ib: e.target.checked,
      assignment: assignment,
      icon_overview_status: iconOverviewStatus,
      custom_report: customReport,
    });
  };

  const sidebarRef = useRef();
  return (
    <div className="clinicWorkflow__main-section">
      <div className="eventsContainer">
        <div className="fullContainer pt-2">
          <OverviewFilter
            autoCompleteOptions={patients}
            onChangeDate={onChangeDate}
            hideProvider={true}
            onChangeAssignment={onChangeAssignment}
            onChangeSlary={onChangeSlary}
            onSelectCustomReport={onSelectCustomReport}
            providers={ScheduleRow || []}
            valueSearch={(value) => valueSearch(value)}
            onSelectFilter0IB={onSelectFilter0IB}
          />
          <div className="tableSection">
            <div className="tableContainer">
              <DataTable
                isBorderThick={true}
                title="pcm_endovascular"
                tableWidth={1920}
                labels={[
                  "Patient Name",
                  "ID",
                  "Encounter",
                  "DOB",
                  "DOS",
                  "Aging",
                  "Primary Insurance",
                  "Secondary Insurance",
                  "Fee",
                  "Allowed Amount",
                  "Insurance Paid",
                  "Insurance Balance",
                  "Patient Balance",
                  "Collection Balance",
                  "Total Balance",
                ]}
                widths={["12%", "4%", "5%", "7%", "7%", "5%", "9%", "9%", "6%", "6%", "6%", "6%", "6%", "6%", "6%"]}
                columns={[
                  { sortable: false, key: "patient_name" },
                  { sortable: false, key: "patient_id" },
                  { sortable: true, key: "ops_claim_id" },
                  { sortable: false, key: "patient_dob" },
                  { sortable: true, key: "dos" },
                  { sortable: true, key: "aging" },
                  { sortable: false, key: "insurance_company" },
                  { sortable: false, key: "secondary_company" },
                  { sortable: true, key: "fee" },
                  { sortable: true, key: "allowed_amount" },
                  { sortable: true, key: "insurance_amount" },
                  { sortable: true, key: "insurance_balance" },
                  { sortable: true, key: "patient_balance" },
                  { sortable: true, key: "collection_balance" },
                  { sortable: true, key: "total_balance" },
                ]}
                sorts={[
                  "",
                  "",
                  sortOption.ops_claim_id,
                  "",
                  sortOption.dos,
                  sortOption.aging,
                  "",
                  "",
                  sortOption.fee,
                  sortOption.allowed_amount,
                  sortOption.insurance_amount,
                  sortOption.insurance_balance,
                  sortOption.patient_balance,
                  sortOption.collection_balance,
                  sortOption.total_balance,
                ]}
                rowData={(tableLoad || []).map((row, index) => ({
                  id: row?.id,
                  patient_name: (
                    <div
                      className="iconField td with-icon"
                      style={{
                        display: "flex",
                        paddingLeft: "0.25rem",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      {row.assignment === "ok_waiting_payment" && (
                        <div className="has-tooltip">
                          <Icon type="clock-circle" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#24A148" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Ok waiting payment"}
                          </span>
                        </div>
                      )}
                      {row.assignment === "needs_review" && (
                        <div className="has-tooltip">
                          <Icon type="warning" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#FF832B" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Needs Review"}
                          </span>
                        </div>
                      )}
                      {row.icon_overview_status === "research" && (
                        <div className="has-tooltip">
                          <Icon type="phone" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#005ef6" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Research Team - Action Required"}
                          </span>
                        </div>
                      )}
                      {row.assignment === "attention_required" && (
                        <div className="has-tooltip">
                          <Icon type="question-circle" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#DA1E28" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Needs Attention"}
                          </span>
                        </div>
                      )}
                      {row.icon_overview_status === "payment_posting" && (
                        <div className="has-tooltip">
                          <Icon type="dollar" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#F1C21B" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Payment Pending"}
                          </span>
                        </div>
                      )}
                      {row.icon_overview_status === "adjust_off" && (
                        <div className="has-tooltip">
                          <Icon type="thunderbolt" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#6929C4" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Adjust Off"}
                          </span>
                        </div>
                      )}
                      {row.icon_overview_status === "fail" && (
                        <div className="has-tooltip">
                          <Icon type="file-excel" style={{ zIndex: 1 }} theme="twoTone" twoToneColor="#DA1E28" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Billing Error"}
                          </span>
                        </div>
                      )}
                      {row.icon_overview_status === "positive_patient_balance" && (
                        <div className="has-tooltip">
                          <Icon type="account-book" style={{ paddingTop: "7px", zIndex: 1 }} theme="twoTone" twoToneColor="#ff7eb6" />
                          <span className="tooltip tooltip-without-border" role="tooltip" style={{ zIndex: 5 }}>
                            {"Collection"}
                          </span>
                        </div>
                      )}
                      {!row.icon_overview_status && row.aging >= 30 && <span style={{ minWidth: "26px" }}></span>}
                      <p style={{ paddingLeft: "0.75rem" }}>{row.patient_name}</p>
                    </div>
                  ),
                  patient_dob: row.patient_dob && moment(row.patient_dob).format("MM/DD/YYYY"),
                  dos: row.date_of_procedure && moment(row.date_of_procedure).format("MM/DD/YYYY"),
                  proceduralist: row.provider_name,
                  fee: row.fee,
                  allowed_amount: row.allowed_amount,
                  total_payment: row.payment,
                  net: row.net,
                  ros: row.location,
                  direct_cost: row.direct_cost,
                  contribution_margin: row.contribution_amount,
                  insurance_balance: row.insurance_balance,
                  patient_balance: row.patient_balance,
                  insurance_amount: row.insurance_amount,
                  ops_claim_id: row.ops_claim_id,
                  aging: row.aging,
                  insurance_company: row.insurance_company,
                  insurance_id: row.insurance_id,
                  secondary_company: row.secondary_company,
                  secondary_insurance_id: row.secondary_insurance_id,
                  patient_id: row.patient_id,
                  collection_balance: row.collection_balance,
                  total_balance: row.total_balance,
                  assignment: row.assignment,
                }))}
                handleSort={(value, item) => {
                  handleSortOption(value, item);
                }}
                fetchList={fetchList}
                loadMore={loadMore}
                handleClickRow={handleRow}
                defaultActive={-1}
                disableDelete={true}
              />
            </div>
          </div>
        </div>
      </div>

      {pcmDetail && activeIndex >= 0 && (
        <OverviewSidebar
          updateLocal={updateLocal}
          ref={sidebarRef}
          updateState={(value, data) => {
            updateState(value, data);
          }}
          moveState={(value, data) => {
            moveState(value, data);
          }}
          detailPCM={activeIndex >= 0 && pcmDetail ? pcmDetail : undefined}
          resource={StaticResource}
          isShow={isSidebar}
          handleCloseSidebar={handleCloseSidebar}
          iconOverviewStatus={iconOverviewStatus}
          assignment={assignment}
        />
      )}
    </div>
  );
};

export default Overview;
